import { useState } from "react";
import { Button } from "@/components/ui/button";
import { ArrowRight, Mail } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { Logo } from "./Logo";
import ContactDialog from "./ContactDialog";
import heroBg from "@/assets/hero-bg-new.png";

const Footer = () => {
  const { t } = useLanguage();
  const [contactOpen, setContactOpen] = useState(false);
  return (
    <footer className="relative overflow-hidden">
      {/* Background Image with Overlay - Same as Hero but inverted gradient */}
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: `url(${heroBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-t from-background/80 via-background/70 to-background" />
      </div>
      
      {/* Content */}
      <div className="relative z-20">
        {/* CTA Section */}
        <section className="py-24 md:py-32 border-t border-border/50">
          <div className="container px-6 md:px-8">
            <div className="max-w-3xl mx-auto text-center animate-fade-in">
              <h2 className="mb-6">
                {t.footer.cta.title}
              </h2>
              <p className="text-xl md:text-2xl text-muted-foreground mb-12">
                {t.footer.cta.description}
              </p>

              <div className="flex justify-center">
                <Button 
                  size="lg" 
                  className="text-lg px-8 py-6 h-auto group hover-lift flex flex-col gap-1"
                  onClick={() => setContactOpen(true)}
                >
                  <span className="flex items-center">
                    {t.footer.cta.buttonMain}
                    <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
                  </span>
                  <span className="text-sm font-normal">{t.footer.cta.buttonSub}</span>
                </Button>
              </div>
              
              <ContactDialog open={contactOpen} onOpenChange={setContactOpen} />
            </div>
          </div>
        </section>

        {/* Bottom Bar with Less Gradient */}
        <div className="border-t border-border/50 py-8 bg-background/90 backdrop-blur-sm">
          <div className="container px-6 md:px-8">
            <div className="flex flex-col md:flex-row justify-between items-center gap-6">
              <div className="flex flex-col items-center md:items-start gap-3">
                <Logo size="md" layout="horizontal" />
                <a 
                  href="mailto:fulltrui@fulltrui.is"
                  className="flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  <Mail className="h-4 w-4" />
                  fulltrui@fulltrui.is
                </a>
              </div>
              
              <div className="flex flex-col items-center md:items-end gap-3">
                <div className="text-sm text-muted-foreground">
                  © {new Date().getFullYear()} Fulltrúi. {t.footer.copyright}
                </div>
              </div>
            </div>
            <div className="text-center mt-6 text-sm text-muted-foreground italic flex items-center justify-center gap-2">
              <span>{t.footer.ps}</span>
              <svg 
                className="w-6 h-6 text-primary animate-pulse" 
                fill="none" 
                strokeWidth="2" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path d="M17 8l4 4m0 0l-4 4m4-4H3" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
